<template>
  <v-container fluid>
    <!-- CONTENTS -->
    <v-row class="pa-2">
      <v-col>
        <v-sheet>
          <v-col>
            <user-container />
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import userContainer from "./AmaterasuPage/UserContainer";

export default {
  components: {
    userContainer,
  },
  data() {
    return {
      //
    };
  },
  created() {
    document.title = this.$t("akito.control") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("akito.control"));
  },
};
</script>

<style></style>
